<template>
    <span v-show="!!legal?.text" :title="legal?.text" :style="style" class="th-badge th-badge-sm th-badge-outline">
        {{ legal?.text }}
    </span>
</template>

<script setup lang="ts">
import { useLegalStatus } from './use-legal-status';
import type { ILegal } from './types';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
    legal_status?: number | string;
}>();

const legal = ref<ILegal>()
const { locale } = useI18n()
onMounted(async() => {
    legal.value = await useLegalStatus(props.legal_status, locale.value)
})

const style = computed(() => {
    return {
        'border-color': legal.value?.color,
        color: legal.value?.color,
    };
});
</script>
